import { render, staticRenderFns } from "./UcResourceStatusCard.yaml?vue&type=template&id=1172be9a&component"
import script from "./UcResourceStatusCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcResourceStatusCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports